import api from 'api'
import Constants from 'Constants'

const { SERVER_PUBLIC_URL } = Constants

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getAccountStatus: builder.query({
      query: ({ businessId, accountId }) => ({
        method: 'GET',
        url: `${SERVER_PUBLIC_URL}/api/v1/businesses/${businessId}/accounts/${accountId}/is-active`,
      }),
    }),
    getAccountActive: builder.query({
      query: ({ accountNumber, invoiceNumber }) => ({
        method: 'GET',
        url: `${SERVER_PUBLIC_URL}/api/v1/portal-user/${accountNumber}/${invoiceNumber}/verify-account`,
      }),
    }),
  }),
})

export const { useLazyGetAccountStatusQuery, useLazyGetAccountActiveQuery } = extendedApi
